import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { LicenseService } from 'common/util/services/license.service'
import { TapeArchiverService } from 'ltfs/services/tapeArchiver.service'
import { IdentityService } from 'main/services/identity.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BackupAddDirModalComponent } from 'ltfs/module'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ArchiveOp extends BaseOperation {
  icon = 'far fa-tape'
  showInSelectionOverflowMenu = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = 90

  constructor (
    private api: APIService,
    private panel: PanelService,
    private license: LicenseService,
    private identity: IdentityService,
    private translate: TranslateService,
    private tapeArchiver: TapeArchiverService,
    private notify: NotifyService,
    private ngbModal: NgbModal,
  ) {
    super()
    this.label = translate.instant('Archive')
  }

  isVisibleFor () {
    return !this.panel.active && this.license.hasComponent('ltfs') && this.identity.hasPermission('ltfs:restore')
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present
  }

  async run ({ dirs, bundles }) {
    let count = 0

    if (dirs.length > 0) {
      const m = this.ngbModal.open(BackupAddDirModalComponent)
      m.componentInstance.paths = dirs.map(x => x.fullPath)
      const result = await m.result.catch(() => null)
      if (!result) {
        return
      }
      for (const path of result) {
        this.tapeArchiver.enqueue(path)
        count += 1
      }
    }

    await Promise.all(bundles.map(async bundle => {
      const files = await this.api.mediaLibrary.getAllMediaFiles({ bundle: bundle.id })
      for (const file of files) {
        this.tapeArchiver.enqueue(file.fullPath, false)
        count += 1
      }
    }))

    this.notify.info(this.translate.instant('%s files enqueued for archiving').replace('%s', `${count}`))
  }
}

MediaOperationsService.register(ArchiveOp)
